import { ADD_TAKEAWAY_REFRESHING_RESTAURANT_ID, APPEND_TAKEAWAY_RESTAURANTS, REMOVE_TAKEAWAY_REFRESHING_RESTAURANT_ID, SET_TAKEAWAY_RESTAURANT, SET_TAKEAWAY_RESTAURANTS, SET_TAKEAWAY_RESTAURANTS_TOTAL_LENGTH, SET_TAKEAWAY_RESTAURANT_IS_NOT_VALID, SET_TAKEAWAY_SHOW_CREATE_RESTAURANT_ERROR_MODAL, SET_TAKEAWAY_SHOW_LOGIN_FAILED_MODAL, UPDATE_TAKEAWAY_RESTAURANTS } from '../../actionTypes/takeawayRestaurant'

const initialState = {
	restaurants: [],
	restaurantsTotalLength: 0,
	restaurant: null,
	showCreateRestaurantErrorModal: false,
	showLoginFailedModal: false,
	restaurantIsNotValid: false,
	refreshingRestaurantIds: []
}

export function takeawayRestaurantReducer(state = initialState, action) {
	switch (action.type) {
		case SET_TAKEAWAY_RESTAURANTS:
			return {
				...state,
				restaurants: action.value
			}
		case SET_TAKEAWAY_RESTAURANTS_TOTAL_LENGTH:
			return {
				...state,
				restaurantsTotalLength: action.value
			}
		case SET_TAKEAWAY_RESTAURANT:
			return {
				...state,
				restaurant: action.value
			}
		case APPEND_TAKEAWAY_RESTAURANTS:
			return {
				...state,
				restaurants: state.restaurants ? state.restaurants.concat(...action.value) : action.value
			}
		case UPDATE_TAKEAWAY_RESTAURANTS:
			return {
				...state,
				restaurants: state.restaurants.map(restaurant => restaurant.id === action.value.id ? action.value : restaurant)
			}
		case ADD_TAKEAWAY_REFRESHING_RESTAURANT_ID:
			return {
				...state,
				refreshingRestaurantIds: [...state.refreshingRestaurantIds, action.value]
			}
		case REMOVE_TAKEAWAY_REFRESHING_RESTAURANT_ID:
			return {
				...state,
				refreshingRestaurantIds: state.refreshingRestaurantIds.filter(id => id !== action.value)
			}
		case SET_TAKEAWAY_SHOW_CREATE_RESTAURANT_ERROR_MODAL:
			return {
				...state,
				showCreateRestaurantErrorModal: action.value
			}
		case SET_TAKEAWAY_SHOW_LOGIN_FAILED_MODAL:
			return {
				...state,
				showLoginFailedModal: action.value
			}
		case SET_TAKEAWAY_RESTAURANT_IS_NOT_VALID:
			return {
				...state,
				restaurantIsNotValid: action.value
			}

		default:
			return state
	}
}
